import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import Loader from "@/components/widgets/loader.vue";
import { PAFormQuestionModel } from "@/store/models/paForm/paFormQuestionDTO";
import { Draggable } from "vue-smooth-dnd";
let FormQuestionComponent = /** @class */ (() => {
    var _a;
    let FormQuestionComponent = class FormQuestionComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.formQaField = false;
            this.editedQuestion = "";
        }
        DuplicateQuestion() {
            const duplicatedQuestion = { ...this.question };
            duplicatedQuestion.question = "Copy-" + duplicatedQuestion.question;
            this.$emit("duplicate-question", { duplicatedQuestion, originalQuestion: this.question });
        }
        DeleteQuestion() {
            this.$emit("delete-question", this.question);
        }
        EditQuestion() {
            this.formQaField = true;
        }
        saveEditedQuestion() {
            if (this.question.question.trim() != "") {
                this.question.question = this.question.question.trim();
                this.formQaField = false;
            }
            else {
                this.formQaField = true;
            }
        }
        checkAnswer() {
            if (this.question.question.trim() == "") {
                this.DeleteQuestion();
                this.formQaField = false;
            }
            else {
                this.saveEditedQuestion();
            }
        }
        created() { }
        destroyed() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], FormQuestionComponent.prototype, "mode", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PAFormQuestionModel !== "undefined" && PAFormQuestionModel) === "function" ? _a : Object)
    ], FormQuestionComponent.prototype, "question", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], FormQuestionComponent.prototype, "questionIndex", void 0);
    FormQuestionComponent = __decorate([
        Component({
            name: "formQuestionComponent",
            components: {
                simplebar,
                Loader,
                Draggable,
            },
        })
    ], FormQuestionComponent);
    return FormQuestionComponent;
})();
export default FormQuestionComponent;
